module.exports = __webpack_public_path__ + "media/images/costumes/top/dress/thumbnail-5-23de8e86f9cf1f1d722a4ee176634bc6.jpg";